<template>
  <div class="page-container">
    <!-- 固定导航栏 -->
    <nav class="navbar" :class="{ 'navbar-fixed': isNavbarFixed, 'navbar-scrolled': isScrolled }">
      <div class="navbar-content">
        <div class="navbar-brand">
          <img src="./assets/img/FigmaDDSSlicePNG1f52009cf8f709682e81af452679a99e.png" alt="Logo" class="navbar-logo" />
          <span class="navbar-title">中广天择多视角视频数据集</span>
        </div>
        <div class="navbar-menu">
          <a href="/index" class="navbar-item" @click.prevent="goToHome">首页</a>
          <a href="#scene-action" class="navbar-item" @click.prevent="scrollToSection('scene-action')">场景与动作</a>
          <a href="#solo-action" class="navbar-item" @click.prevent="scrollToSection('solo-action')">单人动作</a>
          <a href="#two-interaction" class="navbar-item" @click.prevent="scrollToSection('two-interaction')">双人互动</a>
          <a href="#audio-person" class="navbar-item" @click.prevent="scrollToSection('audio-person')">多人场景</a>
          <!-- <a href="/lanhu_frame#contact" class="navbar-item" @click.prevent="goToContact">联系</a> -->
        </div>
      </div>
    </nav>

    <!-- 页面内容 -->
    <div class="page-content">
      <!-- 场景与动作详情 -->
      <section id="scene-action" class="section scene-action-section">
        <div class="section-header">
          <h2 class="section-title">场景与动作详情</h2>
          <p class="section-subtitle">数据集中部分丰富的场景构成与环境覆盖情况。</p>
        </div>

        <div class="scene-overview">
          <div class="scene-overview-header">
            <img src="./assets/img/FigmaDDSSlicePNG89cd871f34b47b82b4147c0922718488.png" alt="" class="scene-icon" />
            <h3>场景概述 (Scene Overview)</h3>
          </div>
          <p class="scene-overview-desc">
            中广天择多视角数据集涵盖超过
            <span class="highlight">2000种真实环境场景</span>
            兼顾室内外场景，精准选取人物活动密集且符合真实动作逻辑的场景涵盖各类体育场馆、社区、家居、公园、消费场所、舞台演出、田园等，全面还原不同生活、运动、工作场景下的人物工作环境，避免场景单一造成数据局限性。
            <!-- <span class="highlight">8机位同步视图</span>
            (左侧 3x2 网格) 及其对应的
            <span class="highlight">3D骨架重建</span>
            (右侧)。 -->
          </p>
        </div>

        <!-- 场景展示网格 -->
        <div class="scene-grid">

          <div class="scene-card">
            <div class="scene-views">
              <!-- <div class="camera-grid">
                <video class="camera-video" ref="cameraVideo" autoplay muted loop playsinline>
                  <source src="./assets/video/室内健身.mp4" type="video/mp4">
                </video>
              </div> -->
              <div class="skeleton-view">
                <img src="./assets/img/mall.png" alt="" class="skeleton-img" />
              </div>
            </div>
            <div class="scene-info">
              <span class="scene-name">消费场景 (mall)</span>
              <span class="scene-type">室内</span>
            </div>
          </div>

          <div class="scene-card">
            <div class="scene-views">
              <!-- <div class="camera-grid">
                <video class="camera-video" ref="cameraVideo" autoplay muted loop playsinline>
                  <source src="./assets/video/室内酒店跳操.mp4" type="video/mp4">
                </video>
              </div> -->
              <div class="skeleton-view">
                <img src="./assets/img/gym.png" alt="" class="skeleton-img" />
              </div>
            </div>
            <div class="scene-info">
              <span class="scene-name">运动场景 (gym)</span>
              <span class="scene-type">室内</span>
            </div>
          </div>

          <div class="scene-card">
            <div class="scene-views">
              <!-- <div class="camera-grid">
                <video class="camera-video" ref="cameraVideo" autoplay muted loop playsinline>
                  <source src="./assets/video/室外篮球场运动.mp4" type="video/mp4">
                </video>
              </div> -->
              <div class="skeleton-view">
                <img src="./assets/img/community.png" alt="" class="skeleton-img" />
              </div>
            </div>
            <div class="scene-info">
              <span class="scene-name">家居场景 (community)</span>
              <span class="scene-type">室外</span>
            </div>
          </div>

          <div class="scene-card">
            <div class="scene-views">
              <div class="skeleton-view">
                <img src="./assets/img/park.png" alt="" class="skeleton-img" />
              </div>
              <!-- <div class="camera-grid">
                <video class="camera-video" ref="cameraVideo" autoplay muted loop playsinline>
                  <source src="./assets/video/park.mp4" type="video/mp4">
                </video>
              </div> -->
            </div>
            <div class="scene-info">
              <span class="scene-name">室外场景 (park)</span>
              <span class="scene-type">室外</span>
            </div>
          </div>

          <!-- <div class="scene-card">
            <div class="scene-views">
              <div class="camera-grid">
                <video class="camera-video" ref="cameraVideo" autoplay muted loop playsinline>
                  <source src="./assets/video/室外教学楼爵士.mp4" type="video/mp4">
                </video>
              </div>
            </div>
            <div class="scene-info">
              <span class="scene-name">室外舞蹈 (Outdoor Dance)</span>
              <span class="scene-type">室外</span>
            </div>
          </div>

          <div class="scene-card">
            <div class="scene-views">
              <div class="camera-grid">
                <video class="camera-video" ref="cameraVideo" autoplay muted loop playsinline>
                  <source src="./assets/video/室内大堂拉伸.mp4" type="video/mp4">
                </video>
              </div>
            </div>
            <div class="scene-info">
              <span class="scene-name">室内拉伸 (Indoor Stretching)</span>
              <span class="scene-type">室内</span>
            </div>
          </div> -->

        </div>
      </section>

      <!-- 单人动作 -->
      <section id="solo-action" class="section solo-action-section">
        <div class="section-header">
          <img src="./assets/img/FigmaDDSSlicePNG80d4fcca1a86c1f9514cbac4deb6ee59.png" alt="" class="section-icon" />
          <h2 class="section-title">实地测试：单人动作 (Solo action)</h2>
        </div>

        <div class="test-description">
          <p>
            数据集安排了领域专业人士，包括原国家队运动员、全国冠军、国际运动健将、武术太极拳6段、教练员、一级裁判员、专业拳击运动员、20余年太极练习者，省市广场舞大赛团队，从服化道、动作标准均按专业标准把控，从源头保障数据的专业度与权威性。
          </p>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.outdoorBasketball}">
              <video
                class="camera-video"
                ref="outdoorBasketball"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('outdoorBasketball')"
                @canplay="onVideoLoaded('outdoorBasketball')"
                @error="onVideoError('outdoorBasketball')"
              >
                <source src="./assets/video/Outdoor Basketball.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.outdoorBasketball" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室外篮球 (Outdoor Basketball)</span>
            <span class="scene-type">室外</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.outdoorTaiChi}">
              <video
                class="camera-video"
                ref="outdoorTaiChi"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('outdoorTaiChi')"
                @canplay="onVideoLoaded('outdoorTaiChi')"
                @error="onVideoError('outdoorTaiChi')"
              >
                <source src="./assets/video/Outdoor Tai Chi.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.outdoorTaiChi" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室外太极 (Outdoor Tai Chi)</span>
            <span class="scene-type">室外</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.indoorStretching}">
              <video
                class="camera-video"
                ref="indoorStretching"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('indoorStretching')"
                @canplay="onVideoLoaded('indoorStretching')"
                @error="onVideoError('indoorStretching')"
              >
                <source src="./assets/video/Indoor Stretching.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.indoorStretching" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室内拉伸 (Indoor Stretching)</span>
            <span class="scene-type">室内</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.indoorFitness}">
              <video
                class="camera-video"
                ref="indoorFitness"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('indoorFitness')"
                @canplay="onVideoLoaded('indoorFitness')"
                @error="onVideoError('indoorFitness')"
              >
                <source src="./assets/video/Indoor Fitness.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.indoorFitness" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室内健身 (Indoor Fitness)</span>
            <span class="scene-type">室内</span>
          </div>
        </div>

      </section>

      <!-- 双人互动 -->
      <section id="two-interaction" class="section two-person-section">
        <div class="section-header">
          <img src="./assets/img/FigmaDDSSlicePNG6f8b9d9ac166f89a4b49b6972636ea3f.png" alt="" class="section-icon" />
          <h2 class="section-title">实地测试：双人互动 (Two-person interaction)</h2>
        </div>

        <div class="test-description">
          <!-- <p>
            为了检验 FreeMan 及其对应数据集的泛化能力，我们分别在
            <span class="highlight">Human3.6M</span>、<span class="highlight">HuMMan</span> 和
            <span class="highlight">FreeMan</span> 数据集上训练了 HMR 模型。
          </p>
          <p>
            下图展示了分别在上述数据集上训练的 HMR 模型在
            <span class="highlight">3DPW 测试集</span> 上的跨域测试结果。
          </p> -->
          <p>
            为更直观地展示数据集在交互动作方面的表现，我们提供了双人互动的多视角示例。多视角画面可清晰呈现双方的动作衔接、接触点变化与互动过程。
          </p>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.indoorBilliard}">
              <video
                class="camera-video"
                ref="indoorBilliard"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('indoorBilliard')"
                @canplay="onVideoLoaded('indoorBilliard')"
                @error="onVideoError('indoorBilliard')"
              >
                <source src="./assets/video/Indoor Billiard.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.indoorBilliard" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室内台球 (Indoor Billiard)</span>
            <span class="scene-type">室内</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.indoorArchery}">
              <video
                class="camera-video"
                ref="indoorArchery"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('indoorArchery')"
                @canplay="onVideoLoaded('indoorArchery')"
                @error="onVideoError('indoorArchery')"
              >
                <source src="./assets/video/Indoor Archery.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.indoorArchery" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室内射箭 (Indoor Archery)</span>
            <span class="scene-type">室内</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.outdoorCycling}">
              <video
                class="camera-video"
                ref="outdoorCycling"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('outdoorCycling')"
                @canplay="onVideoLoaded('outdoorCycling')"
                @error="onVideoError('outdoorCycling')"
              >
                <source src="./assets/video/Outdoor Cycling.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.outdoorCycling" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室外骑自行车 (Outdoor Cycling)</span>
            <span class="scene-type">室外</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.outdoorSwing}">
              <video
                class="camera-video"
                ref="outdoorSwing"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('outdoorSwing')"
                @canplay="onVideoLoaded('outdoorSwing')"
                @error="onVideoError('outdoorSwing')"
              >
                <source src="./assets/video/Outdoor Swing.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.outdoorSwing" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室外荡秋千 (Outdoor Swing)</span>
            <span class="scene-type">室外</span>
          </div>
        </div>

      </section>

      <!-- 多人场景 -->
      <section id="audio-person" class="section audio-person-section">
        <div class="section-header">
          <img src="./assets/img/FigmaDDSSlicePNG03323601b4984e1c4283e66dedea16ec.png" alt="" class="section-icon" />
          <h2 class="section-title">实地测试：多人场景 (Field Test: audio-Person)</h2>
        </div>

        <div class="audio-description">
          <!-- <p>
            为了验证其在多人场景中的有效性，我们分别对基于
            <span class="highlight">Human3.6M、HuMMan</span> 和
            <span class="highlight">FreeMan</span> 模型训练的
            <span class="highlight">HMR</span> 模型进行了测试。输入视频选自 AIST 数据库。根据库的结果，这些结果是通过
            <span class="highlight">mmHuman3D</span> 中的可视化工具获得的。基于
            <span class="highlight">Human3.6M、HuMMan</span> 和
            <span class="highlight">FreeMan</span> 模型训练的
            <span class="highlight">HMR</span> 模型的测试结果如下所示
          </p> -->
          <p>
            为了便于了解数据集在多人场景中的表现，我们列举了常见的多人动作案例。多视角画面可完整记录多主体的互动关系、动态变化与空间布局。
          </p>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.outdoorSquareDance}">
              <video
                class="camera-video"
                ref="outdoorSquareDance"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('outdoorSquareDance')"
                @canplay="onVideoLoaded('outdoorSquareDance')"
                @error="onVideoError('outdoorSquareDance')"
              >
                <source src="./assets/video/Outdoor Square Dance.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.outdoorSquareDance" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室外广场舞 (Outdoor Square Dance)</span>
            <span class="scene-type">室外</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.outdoorShuttlecock}">
              <video
                class="camera-video"
                ref="outdoorShuttlecock"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('outdoorShuttlecock')"
                @canplay="onVideoLoaded('outdoorShuttlecock')"
                @error="onVideoError('outdoorShuttlecock')"
              >
                <source src="./assets/video/Indoor basketballs.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.outdoorShuttlecock" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室内篮球 (Indoor basketballs)</span>
            <span class="scene-type">室内</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.indoorCleaning}">
              <video
                class="camera-video"
                ref="indoorCleaning"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('indoorCleaning')"
                @canplay="onVideoLoaded('indoorCleaning')"
                @error="onVideoError('indoorCleaning')"
              >
                <source src="./assets/video/Outdoor Skipping.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.indoorCleaning" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室外跳绳 (Outdoor Skipping)</span>
            <span class="scene-type">室外</span>
          </div>
        </div>

        <div class="scene-card">
          <div class="scene-views">
            <div class="camera-grid" :class="{'loading': videoLoadingStates.outdoorTaiChis}">
              <video
                class="camera-video"
                ref="outdoorTaiChis"
                autoplay
                muted
                loop
                playsinline
                @loadeddata="onVideoLoaded('outdoorTaiChis')"
                @canplay="onVideoLoaded('outdoorTaiChis')"
                @error="onVideoError('outdoorTaiChis')"
              >
                <source src="./assets/video/Outdoor Tai Chis.mp4" type="video/mp4">
              </video>
              <div v-if="videoLoadingStates.outdoorTaiChis" class="video-loading-hint">
                <div class="loading-spinner"></div>
                <div class="loading-text">视频加载中，请稍后</div>
              </div>
            </div>
          </div>
          <div class="scene-info">
            <span class="scene-name">室外多人太极 (Outdoor Tai Chis)</span>
            <span class="scene-type">室外</span>
          </div>
        </div>

      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanhuFrame1',
  data() {
    return {
      isNavbarFixed: false,
      isScrolled: false,
      // 视频加载状态跟踪
      videoLoadingStates: {
        outdoorBasketball: true,
        outdoorTaiChi: true,
        indoorStretching: true,
        indoorFitness: true,
        indoorBilliard: true,
        indoorArchery: true,
        outdoorCycling: true,
        outdoorSwing: true,
        outdoorSquareDance: true,
        outdoorShuttlecock: true,
        indoorCleaning: true,
        outdoorTaiChis: true
      }
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    this.initCameraVideo();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollY = window.scrollY;

      // 导航栏固定逻辑 - 滚动超过0px就固定
      if (scrollY > 0) {
        this.isNavbarFixed = true;
      } else {
        this.isNavbarFixed = false;
      }

      // 滚动超过100px时添加阴影效果
      if (scrollY > 100) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }

      // 根据滚动位置高亮当前导航项
      this.updateActiveNav();
    },

    updateActiveNav() {
      const sections = ['scene-action', 'solo-action', 'two-interaction', 'audio-person'];
      const scrollPosition = window.scrollY + 150;

      sections.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          const offsetTop = element.offsetTop;
          const height = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + height) {
            const navItem = document.querySelector(`a[href="#${id}"]`);
            if (navItem) {
              document.querySelectorAll('.navbar-item').forEach(item => item.classList.remove('active'));
              navItem.classList.add('active');
            }
          }
        }
      });
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.offsetTop - offset;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    },

    goToHome() {
      this.$router.push('/index');
    },

    // goToContact() {
    //   this.$router.push('/lanhu_frame');
    //   setTimeout(() => {
    //     const contactElement = document.getElementById('contact');
    //     if (contactElement) {
    //       const offset = 80;
    //       const elementPosition = contactElement.offsetTop - offset;
    //       window.scrollTo({
    //         top: elementPosition,
    //         behavior: 'smooth'
    //       });
    //     }
    //   }, 100);
    // },

    initCameraVideo() {
      // 处理视频自动播放（浏览器兼容性）- 增强版
      this.$nextTick(() => {
        const video = this.$refs.cameraVideo;
        if (!video) return;

        // 确保视频静音（提高自动播放成功率）
        video.muted = true;

        // 尝试自动播放
        const playPromise = video.play();

        if (playPromise !== undefined) {
          playPromise.then(() => {
            console.log('Camera video autoplay success');
            // 移除视觉提示
            this.removeCameraPlayHint();
          }).catch(error => {
            console.log('Camera video autoplay prevented:', error);
            // 添加视觉提示和点击事件
            this.addCameraPlayHint();
          });
        }
      });
    },

    // 添加相机视频播放提示
    addCameraPlayHint() {
      this.$nextTick(() => {
        const video = this.$refs.cameraVideo;
        if (!video) return;

        // 添加点击事件触发播放
        const enableVideoPlayback = () => {
          if (video.paused) {
            video.play().then(() => {
              console.log('点击触发视频播放成功');
              // 播放成功后移除监听器
              document.removeEventListener('click', enableVideoPlayback);
              document.removeEventListener('touchstart', enableVideoPlayback);
              // 移除视觉提示
              this.removeCameraPlayHint();
            }).catch(err => {
              console.log('点击播放仍然失败:', err);
            });
          }
        };

        // 同时监听点击和触摸事件
        document.addEventListener('click', enableVideoPlayback, { once: false });
        document.addEventListener('touchstart', enableVideoPlayback, { once: false });

        // 创建播放按钮提示
        const container = video.parentElement;
        if (container && !container.querySelector('.video-play-hint')) {
          const hint = document.createElement('div');
          hint.className = 'video-play-hint';
          hint.style.cssText = `
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            height: 50px;
            background: rgba(220, 38, 38, 0.85);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 20px;
            cursor: pointer;
            z-index: 10;
            box-shadow: 0 4px 12px rgba(0,0,0,0.3);
            transition: transform 0.2s ease;
          `;
          hint.innerHTML = '▶';
          hint.onmouseenter = () => hint.style.transform = 'translate(-50%, -50%) scale(1.1)';
          hint.onmouseleave = () => hint.style.transform = 'translate(-50%, -50%) scale(1)';
          hint.onclick = () => {
            video.play().then(() => {
              hint.remove();
              // 移除全局监听器
              document.removeEventListener('click', enableVideoPlayback);
              document.removeEventListener('touchstart', enableVideoPlayback);
            });
          };
          container.style.position = 'relative';
          container.appendChild(hint);
        }
      });
    },

    // 移除相机视频播放提示
    removeCameraPlayHint() {
      const video = this.$refs.cameraVideo;
      if (!video) return;

      const container = video.parentElement;
      if (container) {
        const hint = container.querySelector('.video-play-hint');
        if (hint) hint.remove();
      }
    },

    // 视频加载完成处理
    onVideoLoaded(videoKey) {
      if (Object.prototype.hasOwnProperty.call(this.videoLoadingStates, videoKey)) {
        this.videoLoadingStates[videoKey] = false;
      }
    },

    // 视频加载错误处理
    onVideoError(videoKey) {
      if (Object.prototype.hasOwnProperty.call(this.videoLoadingStates, videoKey)) {
        this.videoLoadingStates[videoKey] = false;
        console.log(`视频加载失败: ${videoKey}`);
      }
    },
  }
};
</script>

<style scoped>
/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f1f5f9;
}

/* 导航栏样式 */
.navbar {
  background: rgba(15, 23, 42, 0.95);
  border-bottom: 1px solid rgba(51, 65, 85, 1);
  transition: all 0.3s ease;
  z-index: 1000;
}

.navbar.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
}

.navbar.navbar-scrolled {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  background: rgba(15, 23, 42, 0.98);
}

.navbar-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.navbar-logo {
  width: 47px;
  height: 19px;
}

.navbar-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Noto Sans SC', sans-serif;
  white-space: nowrap;
}

.navbar-menu {
  display: flex;
  gap: 30px;
  align-items: center;
}

.navbar-item {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Noto Sans SC', sans-serif;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
}

.navbar-item:hover,
.navbar-item.active {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

/* 页面内容 */
.page-content {
  margin-top: 0;
  padding-top: 65px;
}

.section {
  width: 100%;
  padding: 60px 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.section-title {
  font-size: 32px;
  font-weight: 700;
  color: #0f172a;
  font-family: 'Noto Sans SC', sans-serif;
  margin-bottom: 8px;
}

.section-subtitle {
  font-size: 16px;
  color: #64748b;
  margin-top: 8px;
}

.section-icon {
  width: 8px;
  height: 33px;
  margin-bottom: 12px;
}

.highlight {
  color: #2563eb;
  font-weight: 600;
}

/* 场景与动作详情 */
.scene-action-section {
  background: #ffffff;
}

/* 场景概述 */
.scene-overview {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid #e2e8f0;
}

.scene-overview-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.scene-overview-header h3 {
  font-size: 18px;
  color: #0f172a;
}

.scene-overview-desc {
  font-size: 14px;
  line-height: 20px;
  color: #475569;
  margin-bottom: 8px;
}

/* 场景网格 */
.scene-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 32px;
}

.scene-card {
  background: white;
  border-radius: 12px;
  padding: 19px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  height: 90%;
  display: flex;
  flex-direction: column;
}

.scene-views {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex: 1;
  min-height: 200px;
}

.camera-grid {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 250px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.camera-img {
  width: 100%;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

.camera-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
  display: block;
}

.camera-placeholder {
  width: 100%;
  height: 50px;
  background: #f1f5f9;
  border-radius: 4px;
}

.skeleton-view {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 8px;
  padding: 8px;
}

.skeleton-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.scene-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.scene-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.scene-type {
  font-size: 12px;
  padding: 4px 8px;
  background: #eff6ff;
  color: #2563eb;
  border-radius: 4px;
  font-weight: 500;
}

/* 单人动作和双人互动 */
.solo-action-section,
.two-person-section {
  background: #f8fafc;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.solo-action-section .section-header,
.solo-action-section .test-description,
.two-person-section .section-header,
.two-person-section .test-description {
  grid-column: 1 / -1;
}

/* 确保单人动作和双人互动的场景卡片有合适的高度 */
.solo-action-section .scene-card,
.two-person-section .scene-card {
  height: auto;
  min-height: 320px;
}

.solo-action-section .scene-views,
.two-person-section .scene-views {
  min-height: 220px;
  height: 220px;
}

.test-description {
  background: white;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.test-description p {
  font-size: 14px;
  line-height: 20px;
  color: #475569;
  margin-bottom: 8px;
}

.comparison-chart {
  background: white;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 16px;
  border: 1px solid #e2e8f0;
}

.chart-row {
  display: flex;
  gap: 24px;
  align-items: center;
}

.dataset-labels {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 120px;
}

.label-item {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  height: 40px;
  display: flex;
  align-items: center;
}

.chart-bars {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bar-group {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 40px;
}

.bar-label {
  min-width: 100px;
  font-size: 12px;
  color: #64748b;
}

.bar {
  flex: 1;
  height: 24px;
  background: #e2e8f0;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.bar.highlighted {
  background: linear-gradient(90deg, #3b82f6, #2563eb);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

.action-examples {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.example-item {
  flex: 1;
  min-width: 200px;
  background: white;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.env {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.action {
  font-size: 14px;
  color: #0f172a;
  font-weight: 600;
}

/* 多人场景 */
.audio-person-section {
  background: white;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.audio-person-section .section-header,
.audio-person-section .audio-description {
  grid-column: 1 / -1;
}

/* 确保多人场景的场景卡片有合适的高度 */
.audio-person-section .scene-card {
  height: auto;
  min-height: 320px;
}

.audio-person-section .scene-views {
  min-height: 220px;
  height: 220px;
}

.audio-description {
  background: #f8fafc;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.audio-description p {
  font-size: 14px;
  line-height: 20px;
  color: #475569;
}

.video-comparison {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.video-label {
  background: #f8fafc;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  text-align: center;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.video-item {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.video-item img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .navbar-menu {
    gap: 20px;
  }

  .scene-grid,
  .solo-action-section,
  .two-person-section,
  .audio-person-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .navbar-content {
    flex-direction: column;
    height: auto;
    gap: 12px;
    padding: 12px;
  }

  .navbar-menu {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }

  .navbar-item {
    font-size: 12px;
    padding: 6px 8px;
  }

  .section {
    padding: 40px 16px;
  }

  .section-title {
    font-size: 24px;
  }

  .scene-views {
    flex-direction: column;
  }

  .camera-grid {
    min-height: 200px;
  }

  .chart-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .dataset-labels {
    width: 100%;
  }

  .action-examples {
    flex-direction: column;
  }

  .example-item {
    min-width: 100%;
  }

  .video-grid {
    grid-template-columns: 1fr;
  }

  /* 移动端优化单人动作和多人场景的视频显示 */
  .solo-action-section .scene-card,
  .two-person-section .scene-card,
  .audio-person-section .scene-card {
    min-height: 280px;
  }

  .solo-action-section .scene-views,
  .two-person-section .scene-views,
  .audio-person-section .scene-views {
    min-height: 180px;
    height: 180px;
  }
}

@media (max-width: 480px) {
  .navbar-title {
    font-size: 14px;
  }

  .section-title {
    font-size: 20px;
  }

  .scene-grid {
    grid-template-columns: 1fr;
  }

  .camera-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  .camera-img {
    height: 40px;
  }
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}

/* 加载动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section {
  animation: fadeInUp 0.6s ease-out;
}

/* 视频加载提示样式 */
.camera-grid.loading {
  position: relative;
}

.video-loading-hint {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  backdrop-filter: blur(2px);
}

.loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.loading-text {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  padding: 0 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 确保视频容器有相对定位 */
.camera-grid {
  position: relative;
}
</style>
